// Module-level query ID counter shared between load and panel-close actions
// for stale-response guarding.
export let latestQueryId = 0;

export function incrementQueryId(): number {
    return ++latestQueryId;
}

export function getLatestQueryId(): number {
    return latestQueryId;
}
